<template>
    <div>
        <h2 v-if="title">{{ title }}</h2>
        <div class="revision" v-for="revision in revisions">
            <h4 v-if="revisions.length > 1" class="tag revision__title">{{ revision.title }}</h4>
            <p class="revision__container submission submission--answer">{{ revision.submission }}</p>
        </div>
    </div>
</template>


<script>

import { sorter } from 'js/helpers/transformers'

export default {
    props: {
        title: {},
        submissions: {},
        showVersions: {
            type: Boolean,
            default: false,
        }
    },
    computed: {

        revisions: function() {
            const revisions = this.submissions.map( s => ({
                title: 'versie ' + (s.revision + 1),
                submission: this.getSubmissionValue(s)
            })).sort( sorter('revision') )

            return this.showVersions ? revisions : revisions.slice(-1)
        }

    },
    methods: {

        getSubmissionValue: function(submission) {
            if ( submission == null ) {
                return ''
            }
            return typeof submission.data === 'string' ? submission.data : '[ Werk niet herkend ]'
        },

    }
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Question.vue?443f82f0